<template>
	<div>
	
		<div class="commonBox" id="policyBox">
			<div>
				<div>
					
					<p>일삼사삼사공은(이하 '회사'로 칭합니다) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립 · 공개합니다.</p>
					
					<p class="big">제1조 (개인정보의 처리목적)</p>
					<p class="info">
						회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br><br>

						① 개발문의 개인정보<br>
						개발 문의 시 제공에 따른 본인 식별, 유지 · 관리, 서비스 부정이용 방지 목적으로 개인정보를 처리합니다.<br><br>

						② 개인정보처리자의 개인정보 처리업무<br>
							개인정보 처리업무에 따른 처리목적으로 개인정보를 처리합니다.
					</p>

					<p class="big">제2조 (개인정보의 처리 및 보유기간)</p>
					<p class="info">
						① 회사는 법령에 따른 개인정보 보유 · 이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유 · 이용기간 내에서 개인정보를 처리 · 보유합니다.<br>

						② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br>
						1. 개발문의 개인정보 : 개발문의 완료 시까지
					</p>

					<p class="big">제3조 (정보주체 행사방법)</p>
					<p class="info">
						① 정보주체는 회사에 대해 언제든지 개인정보 열람 · 정정 · 삭제 · 처리정지 요구 등의 권리를 행사할 수 있습니다.<br>

						② 제1항에 따른 권리 행사는 회사에 대해 개인정보보호법 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.<br>

						③ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.<br>

						④ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.<br>

						⑤ 회사는 정보주체 권리에 따른 열람의 요구, 정정 · 삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
					</p>

					<p class="big">제4조 (처리하는 개인정보 항목)</p>
					<p class="info">
						회사는 다음의 개인정보 항목을 처리하고 있습니다.<br><br>

						① 개발문의 개인정보<br>
						항목 : 성함(상호명), 연락처<br><br>

						② 인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다.<br>IP주소, 쿠키, 서비스 이용기록, 방문기록
					</p>

					<p class="big">제5조 (개인정보의 파기)</p>
					<p class="info">
						회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.<br><br>

						①  정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.<br>

						② 개인정보 파기의 절차 및 방법은 다음과 같습니다.<br>
						1. 파기절차<br>
						회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.<br>
						2. 파기방법<br>
						회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
					</p>

					<p class="big">제6조 (개인정보의 안전성 확보조치)</p>
					<p class="info">
						회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.<br><br>
					   1. 관리적 조치 : 내부관리계획 수립 · 시행 등<br>
					   2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화 등
					</p>

					<p class="big">제7조 (개인정보 자동 수집 장치의 설치 ∙ 운영 및 거부에 관한 사항)</p>
					<p class="info">
						회사는 정보주체의 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용하지 않습니다.
					</p>

					<p class="big">제8조 (개인정보 보호책임자)</p>
					<p class="info">
						회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br><br>

						① 개인정보 보호책임자<br>
						성명 : 주명왕성<br>
						직책 : 관리팀 대표<br>
						연락처 : 010-4946-7841<br><br>

						② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.
					</p>

					<p class="big">제9조 (권익침해 구제방법)</p>
					<p class="info">
						정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.<br><br>

						1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)<br>
						2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)<br>
						3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr)<br>
						4. 경찰청 : (국번없이) 182 (cyberbureau.police.go.kr)<br><br>

						「개인정보보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정 · 삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.<br><br>

						※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다.
					</p>

					<p class="big">제10조 (개인정보 처리방침 변경)</p>
					<p class="info">
						이 개인정보 처리방침은 2022년 05월 23일부터 적용됩니다.
					</p>
					
				</div>
			</div>
		</div>
		
	</div>
</template>

<style>
	#policyBox p { width: 100%; float: left; line-height: 24px; }
	#policyBox p.big { font-size: 16px; font-weight: bold; margin-bottom: 10px; margin-top: 20px; } 
	#policyBox p.info { font-size: 12px; margin-bottom: 5px; } 
	#policyBox p:first-of-type { margin-top: 0; }
	#policyBox p:last-of-type { margin-bottom: 0; }
</style>

<script>
	var $;
	
	export default {
		name : "home",
		data : function(){
			return {
				topVisualTitle : "개인정보처리방침",
				topVisualSub : "일삼사삼사공의 개인정보처리방침에 대해 안내드립니다."
			}
		},
		methods : {
			pageLoad : function(){
				$ = this;
				
				$.$parent.pageOpen();
				$.$parent.topVisualTitle = $.topVisualTitle;
				$.$parent.topVisualSub = $.topVisualSub;
			}
		},
		mounted : function(){
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/policyPersonal.vue